// Centralized configuration for multiple environments
export type Environment = 'local' | 'staging' | 'production';

export interface Config {
  /** Current environment */
  env: Environment;
  /** Base URL for API requests */
  apiUrl: string;
  /** Firebase client config */
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  /** Chrome extension identifiers */
  extensionId: string;
  extensionUrl: string;
}

// Determine environment: uses VITE_APP_ENV or defaults to 'local'
const env = (import.meta.env.VITE_APP_ENV as Environment) || 'local';

// Base API URL
const apiUrl = import.meta.env.VITE_API_URL!;

// Firebase configuration from env
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY!,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN!,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID!,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID!,
  appId: import.meta.env.VITE_FIREBASE_APP_ID!,
};

// Extension identifiers
const extensionId = import.meta.env.VITE_CHROME_EXTENSION_ID!;
const extensionUrl = import.meta.env.VITE_CHROME_EXTENSION_URL!;

// Exported centralized config
export const config: Config = {
  env,
  apiUrl,
  firebase: firebaseConfig,
  extensionId,
  extensionUrl,
};
